export const tr = {
    'deleted-success': 'Yeniden pazarlama koşulu silindi',
    'error-delete-retargeting-list-item': 'Yeniden pazarlama koşulu silinemedi'
};
